var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCro(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 20,
    viewBox: "0 0 30 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8883_32415)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H30V20H0V0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0H30V6.66667H0V0Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 13.333H30V19.9997H0V13.333Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0879 6.62028V4.04718L19.1113 3.20508L20.1464 4.04718V6.62028H18.0879ZM11.9125 6.62028V4.04718L10.9008 3.20508L9.854 4.04718V6.62028H11.9125ZM13.971 6.62028V4.04718L15.0002 3.20508L16.0294 4.04718V6.62028H13.971Z",
    fill: "#338AF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0878 6.62028H16.0293V4.04718L17.0527 3.20508L18.0878 4.04718V6.62028ZM13.9708 6.62028H11.9124V4.04718L12.9357 3.20508L13.9708 4.04718V6.62028Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.85376 6.62012V12.5792C9.85376 14.0002 10.6959 15.2809 11.9239 16.0529C13.1695 16.8365 14.3859 16.9125 15 16.9125C15.614 16.9125 16.8362 16.8131 18.076 16.047C19.3041 15.2868 20.1462 13.9944 20.1462 12.5792V6.62012H9.85376Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.82446 6.59082H20.1753V12.5791C20.1753 14.0062 19.3264 15.3073 18.0913 16.0718C16.8452 16.8418 15.6169 16.9417 14.9999 16.9417C14.3833 16.9417 13.1606 16.8654 11.9083 16.0776C10.6735 15.3014 9.82446 14.0121 9.82446 12.5791V6.59082ZM9.88294 6.6493V12.5791C9.88294 13.9882 10.7181 15.2604 11.9394 16.0281C13.1784 16.8075 14.3884 16.8832 14.9999 16.8832C15.611 16.8832 16.8271 16.7842 18.0605 16.0221C19.2816 15.2662 20.1169 13.9824 20.1169 12.5791V6.6493H9.88294Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.854 6.62012H11.9125V8.6786H9.854V6.62012ZM13.971 6.62012H16.0294V8.6786H13.971V6.62012ZM18.0879 6.62012H20.1464V8.6786H18.0879V6.62012ZM11.9125 8.6786H13.971V10.7371H11.9125V8.6786ZM16.0294 8.6786H18.0879V10.7371H16.0294V8.6786ZM9.854 10.7371H11.9125V12.7956H9.854V10.7371ZM11.9125 12.7956H13.971V14.854H11.9125V12.7956ZM13.971 10.7371H16.0294V12.7956H13.971V10.7371ZM18.0879 10.7371H20.1464V12.7956H18.0879V10.7371ZM16.0294 12.7956H18.0879V14.854H16.0294V12.7956ZM18.0879 16.0412C18.5908 15.7254 19.0353 15.3219 19.3745 14.854H18.0879V16.0412ZM10.6259 14.854C10.9651 15.3219 11.4037 15.7254 11.9125 16.047V14.854H10.6259ZM13.971 14.854V16.8248C14.392 16.895 14.7487 16.9125 15.0002 16.9125C15.2517 16.9125 15.6084 16.895 16.0294 16.8189V14.854H13.971V14.854Z",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8883_32415"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 20,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCro);
export default __webpack_public_path__ + "static/media/cro.bc02479e41f45b8423b23057638cb825.svg";
export { ForwardRef as ReactComponent };